import { useEffect, useState } from "react";
import { useXarrow } from "react-xarrows";

export function useArrowSync() {
  const updateXarrow = useXarrow();
  const [renderTrigger, setRenderTrigger] = useState(0);

  useEffect(() => {
    let timeoutId;

    const syncArrows = () => {
      clearTimeout(timeoutId);
      
      timeoutId = setTimeout(() => {
        setRenderTrigger((prev) => prev + 1);
        setTimeout(updateXarrow, 50);
      }, 100);
    };

    const initTimeout = setTimeout(syncArrows, 50);

    window.addEventListener("resize", syncArrows);
    window.addEventListener("scroll", syncArrows, true);

    const observer = new MutationObserver((mutations) => {
      const isOnlyArrows = mutations.every((mutation) => {
        const tag = mutation.target.nodeName.toLowerCase();
        return tag === "svg" || tag === "path" || tag === "line";
      });

      if (!isOnlyArrows) {
        syncArrows();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true, 
    });

    return () => {
      clearTimeout(initTimeout);
      clearTimeout(timeoutId);
      window.removeEventListener("resize", syncArrows);
      window.removeEventListener("scroll", syncArrows, true);
      observer.disconnect();
    };
  }, [updateXarrow]);

  // RETURN the state here!
  return renderTrigger; 
}